module.exports = "../content/380d3172fab0055a8d74ab12636f5a9b.ttf";